export default {
  steps: {
    0: {
      title: 'Be a regular',
      description: 'View your order history and reorder in just a tap.',
    },
    1: {
      title: 'Get rewards',
      description: 'Keep track of your points and redeem saved rewards from your wallet.',
    },
    2: {
      title: 'Order ahead',
      description: 'Find your nearest location and place an order faster than ever.',
    },
  },
  buttons: {
    skip: 'Skip',
  },
};
